// @ts-strict-ignore
import merge from "lodash/merge";
import type { DevicesObject, DisplayOption } from "./common";

export interface StylesObjectProps {
  grid?: DevicesObject;
  gridArea?: DevicesObject;
  flex?: DevicesObject;
  background?: DevicesObject;
  margin?: DevicesObject;
  padding?: DevicesObject;
  maxWidth?: DevicesObject;
  minWidth?: DevicesObject;
  boxSizing?: DevicesObject;
  border?: DevicesObject;
  borderRadius?: DevicesObject;
  width?: DevicesObject;
  height?: DevicesObject;
  minHeight?: DevicesObject;
  maxHeight?: DevicesObject;
  display?: DevicesObject<DisplayOption>;
  flexFlow?: DevicesObject;
  placeItems?: DevicesObject;
  placeContent?: DevicesObject;
  placeSelf?: DevicesObject;
  justifyContent?: DevicesObject;
  alignItems?: DevicesObject;
  alignContent?: DevicesObject;
  alignSelf?: DevicesObject;
  gap?: DevicesObject;
}

export const stylesObjectDefaults: StylesObjectProps = {
  grid: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  gridArea: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  border: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  flex: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  background: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  margin: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  padding: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  maxWidth: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  minWidth: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  width: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  height: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  minHeight: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  maxHeight: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  display: {
    mobile: "block",
    tablet: "block",
    desktop: "block"
  },
  boxSizing: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  borderRadius: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  flexFlow: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  placeItems: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  placeContent: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  placeSelf: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  justifyContent: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  alignItems: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  alignContent: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  alignSelf: {
    mobile: "",
    tablet: "",
    desktop: ""
  },
  gap: {
    mobile: "",
    tablet: "",
    desktop: ""
  }
};

export const contentfulStyleObjectsToStyles = (
  mobileStyle,
  tabletStyle,
  desktopStyle
): StylesObjectProps => {
  const mobile = mediaStylesToStyles(mobileStyle, "mobile");
  const tablet = mediaStylesToStyles(tabletStyle, "tablet");
  const desktop = mediaStylesToStyles(desktopStyle, "desktop");
  return merge(mobile, tablet, desktop) as StylesObjectProps;
};

const mediaStylesToStyles = (contentfulObject, device) =>
  Object.keys(stylesObjectDefaults).reduce((acc, key) => {
    return contentfulObject?.fields?.[key]
      ? {
          ...acc,
          [key]: { [device]: contentfulObject?.fields?.[key] }
        }
      : acc;
  }, {});
